import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/baoqian.png';
const _withScopeId = n => (_pushScopeId("data-v-e85d9c0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "popup"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "srv-time-selector"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bar bar-1"
}, [/*#__PURE__*/_createElementVNode("h1", null, "选择服务时间")], -1));
const _hoisted_5 = {
  key: 0,
  class: "load"
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 0,
  class: "bd"
};
const _hoisted_8 = {
  class: "hours"
};
const _hoisted_9 = {
  key: 0,
  class: "chose-time"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1,
  class: "tips"
};
const _hoisted_12 = {
  key: 2,
  class: "tips"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "抱歉，暂无服务时间~", -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  key: 1,
  class: "tips pt_50"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "抱歉，暂无服务时间~", -1));
const _hoisted_19 = [_hoisted_17, _hoisted_18];
import { ref, getCurrentInstance } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'dateShose',
  emits: ['time'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const dateShow = ref(true),
      timeShow = ref(false);
    const activeDate = ref(''),
      activeTime = ref(''),
      s_id = ref(''),
      name = ref(''),
      phone = ref(''),
      address = ref(''),
      res_time = ref('');
    const dateLists = ref([]),
      timeLists = ref([]); // 时间点列表
    // 鞋靴洗护获取时间
    const getWashDate = (ID, NAME, PHONE, ADDRESS, DATE) => {
      s_id.value = ID;
      name.value = NAME;
      phone.value = PHONE;
      address.value = ADDRESS;
      activeDate.value = activeTime.value = '';
      dateLists.value = timeLists.value = [];
      if (ID == 33 || ID == 51 || ID == 52) {
        getDateLists();
      } else {
        getDateLists1();
      }
    };
    // 全季产品请求鞋靴时间
    const getDateLists = () => {
      proxy.$api.post(`${proxy.$url}Jdl/precheck`, {
        name: name.value,
        mobile: phone.value,
        fullAddress: address.value
      }).then(res => {
        dateShow.value = false;
        if (Array.isArray(res.data)) {
          let list = [];
          for (let s of res.data) {
            list.push({
              date: s.dateKey,
              timeSlotDetailList: s.pickupSliceTimes
            });
          }
          dateLists.value = list;
          timeLists.value = list[0].timeSlotDetailList;
        } else {
          dateLists.value = timeLists.value = [];
        }
      }).catch(err => {
        dateShow.value = false;
      });
    };
    const getDateLists1 = () => {
      proxy.$api.post(`${proxy.$url}ServiceDate/getJdxhDate`, {
        s_id: s_id.value,
        name: name.value,
        phone: phone.value,
        full_address: address.value,
        res_time: activeDate.value
      }).then(res => {
        if (res.status == 1) {
          if (!activeDate.value) {
            dateLists.value = res.data;
          }
          timeLists.value = res.data[0].timeSlotDetailList;
        } else {
          if (activeDate.value) {
            timeLists.value = [];
          } else {
            dateLists.value = timeLists.value = [];
            activeTime.value = '';
          }
        }
        if (activeDate.value) {
          timeShow.value = false;
        } else {
          dateShow.value = false;
        }
      }).catch(err => {
        dateShow.value = false;
        timeLists.value = [];
      });
    };
    // 清空时间列表
    const clearList = () => {
      dateLists.value = timeLists.value = [];
    };
    __expose({
      getWashDate,
      clearList
    });
    // 选择日期
    const startTime = ref(''),
      endTime = ref('');
    ;
    const chooseDate = ({
      title
    }) => {
      if (s_id.value == 33 || s_id.value == 51 || s_id.value == 52) {
        let arr = dateLists.value.filter(item => item.date == title);
        timeLists.value = arr[0].timeSlotDetailList;
      } else {
        activeDate.value = title;
        timeLists.value = [];
        timeShow.value = true;
        getDateLists1();
      }
      activeTime.value = '';
    };
    // 选择时间点
    const chooseTime = hour => {
      activeTime.value = hour.startTime + '-' + hour.endTime;
      startTime.value = hour.startTime;
      endTime.value = hour.endTime;
    };
    // 确定按钮
    const emit = __emit;
    const submitFunc = () => {
      if (!activeTime.value) return;
      emit('time', activeDate.value, startTime.value, endTime.value);
    };
    return (_ctx, _cache) => {
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("section", _hoisted_3, [_hoisted_4, dateShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_loading, {
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [_createTextVNode("时间获取中...")]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [dateLists.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_van_tabs, {
        active: activeDate.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeDate.value = $event),
        onClickTab: chooseDate
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateLists.value, (item, index) => {
          return _openBlock(), _createBlock(_component_van_tab, {
            title: item.date,
            name: item.date,
            key: index
          }, null, 8, ["title", "name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"]), _createElementVNode("div", _hoisted_8, [timeLists.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeLists.value, (item, index) => {
        return _openBlock(), _createElementBlock("button", {
          class: _normalizeClass([{
            'not-can-use': s_id.value != 33 && s_id.value != 51 && s_id.value != 52 && !item.isAvailable
          }, {
            chose: activeTime.value == item.startTime + '-' + item.endTime
          }]),
          key: index,
          onClick: $event => chooseTime(item)
        }, _toDisplayString(item.startTime + '-' + item.endTime), 11, _hoisted_10);
      }), 128))])) : timeShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_loading, {
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [_createTextVNode("时间段获取中...")]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))]), _createElementVNode("div", {
        class: "out"
      }, [_createElementVNode("button", {
        class: "submit",
        onClick: submitFunc
      }, "确定")])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))]))])])]);
    };
  }
});